<template>
  <div id="home" class="container_rwd">
    <!-- <head-image /> -->
    <main-slider cms-banner-section-id="bs_HOMEPAGE_BETWEEN_BOKS" />
    <section class="container px15">
      <div class="row">
        <div class="col-xs-12 col-md-3 hidden-xs">
          <div class="left-banners">
            <!-- <promoted-offers /> -->
            <Box :categoryProps="getCurrentCategory.catalog" :box="box" class="mt30" v-if="isCalculatorVisible"></Box>
            <cms-block-banner :identifier="'bs_HOMEPAGE_BANNER_LEFT'" :padding="'100%'" />
            <cms-block-banner :identifier="'bs_HOMEPAGE_BANNER_LEFT2'" :padding="'100%'" />
          </div>
        </div>

        <div class="col-xs-12 col-md-9">
          <div class="new-collection container px15">
            <promoted-offers class="visible-xs" />
            <products-slider
              class="h_container-news"
              :title="$t('Everything new')"
              :products="newProducts"
              :config="configSliderNew"
              :categoryProps="categoryProduct.catalog"
              :isBadge="true"
              v-if="newProducts && newProducts.length"
              id="newprod"
            />
            <products-slider
              :title="$t('Popular products')"
              :products="popularProducts"
              :config="configSliderPopular"
              :categoryProps="categoryProduct.catalog"
              :isBadge="true"
              v-if="popularProducts && popularProducts.length"
              id="popular"
            />
            <products-slider
              :title="$t('Promotions of the day')"
              :products="promotions"
              :config="configSliderPromo"
              :categoryProps="categoryProduct.catalog"
              :isBadge="true"
              v-if="promotions && promotions.length"
              id="promo"
            />
          </div>

          <div class="container p15 hidden-xs">
            <cms-block-banner :identifier="'bs_HOMEPAGE_BANNER_BOTTOM'" :item-height="120" />
          </div>
        </div>

        <div class="col-xs-12 visible-xs">
          <div class="left-banners">
            
            <Box :categoryProps="getCurrentCategory.catalog" :box="box" v-if="isCalculatorVisible"></Box>
            <cms-block-banner :identifier="'bs_HOMEPAGE_BANNER_LEFT'" :padding="'100%'" />
            <cms-block-banner :identifier="'bs_HOMEPAGE_BANNER_LEFT2'" :padding="'100%'" />
          </div>
        </div>
      </div>
    </section>

    <!-- <manufacturer-slider
      :css-class="['manufacturer-slider', 'w-100']"
    /> -->
  </div>
</template>

<script>
// query constructor
import { prepareCategoryQuery } from '@vue-storefront/core/modules/catalog/queries/categoryQuery'
import { isServer, onlineHelper } from '@vue-storefront/core/helpers'
import LazyHydrate from 'vue-lazy-hydration'

// Theme core components
import ProductListing from 'theme/components/core/ProductListing'
import HeadImage from 'theme/components/core/blocks/MainSlider/HeadImage'
import MainSlider from 'theme/components/core/blocks/MainSlider/MainSlider'
import CmsBlockBanner from 'theme/components/core/blocks/Cms/BlockBanner'
import ManufacturerSlider from 'theme/components/core/blocks/MultiSlider/ManufacturerSlider'
import Box from 'theme/components/core/blocks/Box/Box'
// Theme local components
import ProductsSlider from 'theme/components/core/ProductsSlider'
import PromotedOffers from 'theme/components/theme/blocks/PromotedOffers/PromotedOffers'
import TileLinks from 'theme/components/theme/blocks/TileLinks/TileLinks'
import { Logger } from '@vue-storefront/core/lib/logger'
import { mapGetters } from 'vuex'
import config from 'config'
import { registerModule } from '@vue-storefront/core/lib/modules'
import { RecentlyViewedModule } from '@vue-storefront/core/modules/recently-viewed'

export default {
  data () {
    return {
      loading: true,
      configSliderPromo: {
        perPageCustom: [
          [1, 1],
          [375, 2],
          [567, 2],
          [768, 2],
          [992, 3],
          [1200, 3],
          [1400, 4]
        ],
        paginationEnabled: false,
        scrollPerPage: false,
        autoplayTimeout: 5000,
        speed: 1000,
        navigationEnabled: true
      },
      configSliderPopular: {
        perPageCustom: [
          [1, 1],
          [375, 2],
          [567, 2],
          [768, 2],
          [992, 3],
          [1200, 3],
          [1400, 4]
        ],
        paginationEnabled: false,
        scrollPerPage: false,
        autoplayTimeout: 5000,
        speed: 1000,
        navigationEnabled: true
      },
      configSliderNew: {
        perPageCustom: [
          [1, 1],
          [375, 2],
          [567, 2],
          [768, 2],
          [992, 3],
          [1200, 3],
          [1400, 4]
        ],
        paginationEnabled: false,
        scrollPerPage: false,
        autoplayTimeout: 5000,
        speed: 1000,
        navigationEnabled: true
      },
      popularStatus: false
    }
  },
  components: {
    HeadImage,
    MainSlider,
    ProductListing,
    PromotedOffers,
    TileLinks,
    LazyHydrate,
    ProductsSlider,
    Box,
    'cms-block-banner': CmsBlockBanner,
    'manufacturer-slider': ManufacturerSlider,
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('homepage', ['getEverythingNewCollection']),
    ...mapGetters({getCurrentCategory: 'category-next/getCurrentCategory'}),
    categories () {
      return this.getCategories
    },
    newProducts () {
      return this.$store.state.categoryhomepage.new_products;
    },
    categoryProduct () {
      return this.getCurrentCategory;
    },
    promotions () {
      return this.$store.state.categoryhomepage.promotions;
    },
    popularProducts () {
      return this.$store.state.categoryhomepage.popular_products;
    },
    morePromotionUrl () {
      return '/wiecej-promocji/' + this.$route.meta.category;
    },
    morePopularUrl () {
      return '/wiecej-popularnych/' + this.$route.meta.category;
    },
    moreNewsUrl () {
      return '/wiecej-nowosci/' + this.$route.meta.category;
    },
    isOnline () {
      return onlineHelper.isOnline
    },
    isLazyHydrateEnabled () {
      return config.ssr.lazyHydrateFor.some(
        field => ['homepage', 'homepage.new_collection'].includes(field)
      )
    },
    box () {
      return {
        heading: "Kalkulator oszczędności",
        image: false,
        imageAlign: "left",
        text: "Sprawdź kwotę oszczędności",
        title: "<strong>Wydajność</strong> Black Point – dziś już legendarna.",
        titleColor: "",
        type: "calc",
        width: "50",
        background: {
          ID: 1202,
          alt: "",
          author: "4",
          status: "inherit",
          subtype: "png",
          title: "bg_kalkulator1",
          type: "image",
          uploaded_to: 38,
          url: "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1.png",
          width: 740,
          caption: "",
          date: "2021-05-05 17:47:58",
          description: "",
          filename: "bg_kalkulator1.png",
          filesize: 118462,
          height: 644,
          icon: "https://blackpointpl.wpengine.com/wp-includes/images/media/default.png",
          id: 1202,
          link: "https://blackpointpl.wpengine.com/strona-glowna/bg_kalkulator1/",
          menu_order: 0,
          mime_type: "image/png",
          modified: "2021-05-05 17:48:29",
          name: "bg_kalkulator1",
          sizes: {
            "1536x1536": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1.png",
            "1536x1536-height": 644,
            "1536x1536-width": 740,
            "2048x2048": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1.png",
            "2048x2048-height": 644,
            "2048x2048-width": 740,
            "large": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1.png",
            "large-height": 644,
            "large-width": 740,
            "main-slider": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1-646x644.png",
            "main-slider-height": 644,
            "main-slider-width": 646,
            "medium": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1-300x261.png",
            "medium-height": 261,
            "medium-width": 300,
            "medium_large": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1.png",
            "medium_large-height": 644,
            "medium_large-width": 740,
            "placeholder": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1-40x35.png",
            "placeholder-height": 35,
            "placeholder-width": 40,
            "post-list": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1-431x323.png",
            "post-list-height": 323,
            "post-list-width": 431,
            "thumbnail": "https://blackpointpl.wpengine.com/wp-content/uploads/2021/05/bg_kalkulator1-150x150.png",
            "thumbnail-height": 150,
            "thumbnail-width": 150
          }
        },
        btn: {
          link: "",
          text: ""
        },
        counter: {
          description: "",
          value: "",
          valueCaption: ""
        },
        gallery: [{
          caption: "Umowę dla klienta",
          image: false
        }, {
          caption: "Zdjęcia dla mamy",
          image: false
        }, {
          caption: "Plakat dla znajomego",
          image: false
        }]
      }
    },
    isCalculatorVisible () {
      const catalog = this.$route.meta.category
      return catalog != config.rootcategories.biuro    
    }
  },
  beforeCreate () {
    registerModule(RecentlyViewedModule)
  },
  async beforeMount () {
    if (this.$store.state.__DEMO_MODE__) {
      const onboardingClaim = await this.$store.dispatch('claims/check', { claimCode: 'onboardingAccepted' })
      if (!onboardingClaim) { // show onboarding info
        this.$bus.$emit('modal-toggle', 'modal-onboard')
        this.$store.dispatch('claims/set', { claimCode: 'onboardingAccepted', value: true })
      }
    }
    // TODO - use prepareCategoryQuery from '@vue-storefront/core/modules/catalog/queries/categoryQuery'
    const catalog = this.$route.meta.category
    let newProductsQuery = prepareCategoryQuery({
      filters: [
        {
          "key": "is_new_product",
          "value": {
            "eq": "true"
          }
        },
        {
          "key": "stock.is_in_stock",
          "value": {
            "eq": "true"
          }
        }
      ]
    });

    let promotionsQuery = prepareCategoryQuery({
      filters: [
        {
          "key": "is_promotion",
          "value": {
            "eq": "true"
          }
        },
        {
          "key": "stock.is_in_stock",
          "value": {
            "eq": "true"
          }
        }       
      ]
    });

    let popularProductsQuery = prepareCategoryQuery({
      filters: [
        {
          "key": "is_suggested",
          "value": {
            "eq": "true"
          }
        },
        {
          "key": "stock.is_in_stock",
          "value": {
            "eq": "true"
          }
        }       
      ]
    });

    const newProductsResult = await this.$store.dispatch('product/list', {
      query: newProductsQuery,
      size: 24,
      sort: 'priority:desc'
    });
    if (newProductsResult) {
      this.$store.state.categoryhomepage.new_products = newProductsResult.items.filter(item => item.catalog === catalog )
    }
    const promotionsResult = await this.$store.dispatch('product/list', {
      query: promotionsQuery,
      size: 24,
      sort: 'priority:desc'
    });
    if (promotionsResult) {
      this.$store.state.categoryhomepage.promotions = promotionsResult.items.filter(item => item.catalog === catalog );
    }

    const popularProductsResult = await this.$store.dispatch('product/list', {
      query: popularProductsQuery,
      size: 24,
      sort: 'priority:desc'
    });
    if (popularProductsResult) {
      this.$store.state.categoryhomepage.popular_products =
        popularProductsResult.items.filter(item => item.catalog === catalog );
    }
  },
  mounted () {
    if (!this.isLoggedIn && localStorage.getItem('redirect')) this.$bus.$emit('modal-show', 'modal-signup')
  },
  watch: {
    isLoggedIn () {
      const redirectObj = localStorage.getItem('redirect')
      if (redirectObj) this.$router.push(redirectObj)
      localStorage.removeItem('redirect')
    }
  },
  async asyncData ({ store, route, context }) { // this is for SSR purposes to prefetch data
    if (context) context.output.cacheTags.add(`home`)
    Logger.info('Calling asyncData in Home Page (core)')()

    await Promise.all([
      store.dispatch('homepage/fetchNewCollection'),
      store.dispatch('category-next/loadCategories', {}),
      store.dispatch('promoted/updateHeadImage'),
      store.dispatch('promoted/updatePromotedOffers')
    ])
  },
  beforeRouteEnter (to, from, next) {
    if (!isServer && !from.name) { // Loading products to cache on SSR render
      next(vm =>
        vm.$store.dispatch('homepage/fetchNewCollection').then(res => {
          vm.loading = false
        })
      )
    } else {
      next()
    }
  },
  metaInfo () {
    return {
      title: this.$route.meta.title || this.$i18n.t('Home Page'),
      meta: this.$route.meta.description ? [{ vmid: 'description', name: 'description', content: this.$route.meta.description }] : []
    }
  }
}
</script>

<style lang="scss" scoped>
  #home {
    padding: 0;

    @media(min-width: 768px) {
      padding-top: 40px;
    }

    @media(min-width: 992px) {
      padding: 60px 30px 0;
    }

    @media(min-width: 1540px) {
      padding: 0 30px;
    }
  }

  .h_container-news {
    min-height: 529px;
  }

  .new-collection {
    margin-top: 30px;

    @media (max-width: 767px) {
      padding-top: 0;
    }
    @media (max-width: 375px) {
      margin-top: 5px;
      padding: 0px !important;
    }
  }
  .left-banners {
    flex-direction: column;
    width: 100%;
  }
</style>
